import { useLocation } from "react-router-dom";

import {
  useVerifyApplicationTokenQuery,
  useVerifyUserInviteEmailQuery,
} from "@/redux/service";
import AdminInviteRegister from "./components/AdminInviteRegister";
import SingleStepRegister from "./components/SingleStepRegister";
import RegisterInvalidLink from "./components/RegisterInvalidLink";
import {
  getRegistrationFlow,
  RegistrationFlow,
} from "./utils/getRegistrationFlow";

const Register = () => {
  const { search } = useLocation();
  const flow = getRegistrationFlow(search);

  switch (flow) {
    case RegistrationFlow.Application:
      return (
        <SingleStepRegister useVerifyToken={useVerifyApplicationTokenQuery} />
      );
    case RegistrationFlow.AdminInvite:
      return <AdminInviteRegister />;
    case RegistrationFlow.MemberInvite:
      return (
        <SingleStepRegister useVerifyToken={useVerifyUserInviteEmailQuery} />
      );
    default:
      return <RegisterInvalidLink />;
  }
};

export default Register;
